import initiatePublishWebsite from './initiate-publish-website';

export default {
  initiatePublishWebsite,
};
